/*
* Palo Alto Theme
*
* Use this file to add custom Javascript to Palo Alto.  Keeping your custom
* Javascript in this fill will make it easier to update Palo Alto. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line

(function () {
  const AVAILABILITY_PARAM = 'filter.v.availability';
  const IN_STOCK_VALUE = '1';

  function syncAvailability(form) {
    if (!form) return;

    const availabilityInput = form.querySelector(
      `input[name="${AVAILABILITY_PARAM}"][value="${IN_STOCK_VALUE}"]`
    );

    if (!availabilityInput) {
      console.warn('[AutoAvailability] Availability input not found');
      return;
    }

    const checkedFilters = Array.from(
      form.querySelectorAll('input[name^="filter."]:checked')
    );

    const nonAvailabilityChecked = checkedFilters.filter(
      (input) => input.name !== AVAILABILITY_PARAM
    );

    const hasOtherFilters = nonAvailabilityChecked.length > 0;

    console.log('--- Sync ---');
    console.log('Checked filters:', checkedFilters.map(i => i.name));
    console.log('Non-availability checked:', nonAvailabilityChecked.map(i => i.name));
    console.log('hasOtherFilters =', hasOtherFilters);
    console.log('Availability checked =', availabilityInput.checked);

    // If other filters exist → ensure availability ON
    if (hasOtherFilters && !availabilityInput.checked) {
      console.log('Auto-checking In Stock');
      availabilityInput.checked = true;
      form.dispatchEvent(new Event('input', { bubbles: true }));
      return;
    }

    // If NO other filters and availability is the only one → turn OFF
    if (!hasOtherFilters && availabilityInput.checked) {
      console.log('Auto-unchecking In Stock');
      availabilityInput.checked = false;
      form.dispatchEvent(new Event('input', { bubbles: true }));
      return;
    }

    console.log('No change needed');
  }

  // When any filter changes
  document.addEventListener('change', function (e) {
    if (!e.target.name || !e.target.name.startsWith('filter.')) return;

    const form = e.target.closest('form');
    if (!form) return;

    setTimeout(() => syncAvailability(form), 0);
  });

  // After Shopify re-renders filters
  document.addEventListener('theme:filters:init', function () {
    const form = document.querySelector('form');
    if (!form) return;

    setTimeout(() => syncAvailability(form), 0);
  });
})();


  // ^^ Keep your scripts inside this IIFE function call to
  // avoid leaking your variables into the global scope.
})();


(() => {
  if (!document.body.classList.contains('template-product')) return;
  const mobile = window.matchMedia('(max-width: 767px)');
  const originals = new WeakMap();
  const warmed = new Set();
  const constrained = () => navigator.connection?.saveData || /(^|-)2g$/.test(navigator.connection?.effectiveType || '');
  const preload = (url, as) => {
    if (!url || warmed.has(url) || constrained()) return;
    warmed.add(url);
    const link = document.createElement('link');
    link.rel = 'preload';
    link.as = as;
    link.href = url;
    link.fetchPriority = 'low';
    document.head.appendChild(link);
  };
  const prepare = () => {
    const slider = document.querySelector('[data-product-single-media-slider]');
    const flickity = slider && window.themeVendor?.Flickity?.data(slider);
    if (!flickity) return;
    if (!originals.has(flickity)) {
      originals.set(flickity, {
        selectedAttraction: flickity.options.selectedAttraction,
        friction: flickity.options.friction
      });
      const warmSelection = () => {
        if (!mobile.matches || constrained()) return;
        preload(window.theme?.assets?.photoswipe, 'script');
        const cells = flickity.cells;
        [flickity.selectedIndex, (flickity.selectedIndex + 1) % cells.length].forEach(index => {
          const cell = cells[index]?.element;
          const image = cell?.querySelector('img');
          if (image) image.loading = 'eager';
          preload(cell?.querySelector('[data-zoom-wrapper]')?.href, 'image');
        });
      };
      flickity.on('change', warmSelection);
      warmSelection();
    }
    Object.assign(flickity.options, mobile.matches
      ? { selectedAttraction: 0.055, friction: 0.38 }
      : originals.get(flickity));
  };
  const schedule = () => {
    if ('requestIdleCallback' in window) window.requestIdleCallback(prepare, { timeout: 1500 });
    else window.setTimeout(prepare, 250);
  };
  if (document.readyState === 'complete') schedule();
  else window.addEventListener('load', schedule, { once: true });
  document.addEventListener('theme:resize:width', schedule);
  document.addEventListener('shopify:section:load', schedule);
  mobile.addEventListener('change', schedule);
})();
